import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const INTERNAL_DOCTOR = 'INTERNAL_DOCTOR';
export const INTERNAL_DOCTOR_SUCCESS = 'INTERNAL_DOCTOR_SUCCESS';
export const INTERNAL_DOCTOR_FAILURE = 'INTERNAL_DOCTOR_FAILURE';

// Action Creators
export const internalDoctorRequest = () => ({
  type: INTERNAL_DOCTOR,
});

export const internalDoctorSuccess = (users) => ({
  type: INTERNAL_DOCTOR_SUCCESS,
  payload: users,
});

export const internalDoctorFailure = (error) => ({
  type: INTERNAL_DOCTOR_FAILURE,
  payload: error,
});

// Thunk Function
export const internalDoctorCallAPI = (external, body) => {
  return async (dispatch) => {
    dispatch(internalDoctorRequest());
    try {
      const response = await postMethodWithToken(url.internalDoctor, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(internalDoctorSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(internalDoctorFailure(error?.message));
    }
  };
};
